import { Component, Input } from '@angular/core';
import { TableRow } from './table-row.interface';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TranslateModule } from '@ngx-translate/core';

import { TooltipComponent } from '../tooltip/tooltip.component';

@Component({
  selector: 'app-reusable-table-expand',
  standalone: true,
  templateUrl: './reusable-table-expand.component.html',
  styleUrls: ['./reusable-table-expand.component.css'],
  imports: [NzLayoutModule, NzTableModule, TranslateModule, TooltipComponent],
})
export class ReusableTableExpandComponent<T extends TableRow> {
  @Input() title: string = '';
  @Input() columns: string[] = [];
  @Input() rowFields: string[] = [];
  @Input() data?: T[] = [];
}
